const subscriptionPT = {
    "view": {
        "table": {
            "title": "Sua Assinatura",
            "column": {
                "subscriptionTier": "Nível de Assinatura",
                "startDate": "Data de Início",
                "currentPeriodStart": "Início do Período Atual",
                "currentPeriodEnd": "Fim do Período Atual",
                "autoRenewal": "Renovação Automática",
                "status": "Status",
                "action": "Ação"
            },
            "label": {
                "status_active": "Ativa",
                "status_incomplete": "Incompleta",
                "status_incomplete_expired": "Incompleta Expirada",
                "status_unpaid": "Não Paga",
                "status_past_due": "Vencida",
                "status_cancelled": "Cancelada",
                "status_expired": "Expirada"
            },
            "actionDropdown": {
                "label": {
                    "action": "Ação"
                },
                "button": {
                    "enableAutoRenewal": "Ativar Renovação Automática",
                    "upgradeSubscription": "Atualizar Assinatura",
                    "cancelSubscription": "Cancelar Assinatura",
                    "resumeSubscription": "Retomar Assinatura",
                    "retryPayment": "Tentar Pagamento Novamente"
                },
                "message": {
                    "successSubscripionResumed": "Sua assinatura foi retomada, sua conta será atualizada em breve!",
                    "successSubscripionCancelled": "Sua assinatura foi configurada para ser cancelada no final do período!",
                    "successSubscripionAutoRenewalEnabled": "Sua assinatura foi configurada para ser renovada automaticamente no final do período!",
                    "activeSubscription": "Você já possui uma assinatura ativa",
                    "incompleteSubscription": "Você tem uma assinatura que está Incompleta."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Cancelar",
                    "enableAutoRenewal": "Ativar renovação automática",
                    "cancelSubscription": "Cancelar subscrição"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Ativar Renovação Automática",
                "body": "Você tem certeza de que deseja ativar a renovação automática para sua assinatura?"
            },
            "cancel": {
                "header": "Cancelar Assinatura",
                "body": "Você tem certeza de que deseja cancelar sua assinatura?"
            },
            "resume": {
                "header": "Retomar Assinatura",
                "body": {
                    "description": "Você tem certeza de que deseja retomar a assinatura?",
                    "note": "<strong>Nota:</strong> O preço mais recente da assinatura será aplicado!"
                },
                "button": {
                    "cancel": "Cancelar",
                    "resume": "Retomar"
                },
                "message": {
                    "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
                }
            },
            "retryPayment": {
                "header": "Tentar Pagamento da Assinatura Novamente",
                "body": {
                    "description": "Você tem certeza de que deseja tentar o pagamento da assinatura novamente?",
                    "note": "<strong>Nota:</strong> O preço mais recente da assinatura será aplicado!"
                },
                "button": {
                    "cancel": "Cancelar",
                    "retry": "Tentar Novamente"
                },
                "message": {
                    "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "O pagamento da assinatura falhou, por favor, tente novamente mais tarde!",
            "errorCardExpired": "Seu cartão expirou. Por favor, adicione um <1>método de pagamento</1> válido e tente o pagamento novamente.",
            "errorNoPaymentMethod": "Você não tem nenhum <1>método de pagamento</1> adicionado ao seu perfil. Por favor, adicione um <3>método de pagamento</3> válido e tente o pagamento novamente.",
            "moduleNoAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Escolha Seu Plano",
            "button": {
                "startNow": "Começar Agora"
            }
        },
        "message": {
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        }
    },
    "upgrade": {
        "form": {
            "title": "Atualize Sua Assinatura",
            "button": {
                "upgrade": "Atualizar",
                "currentPlan": "Plano Atual"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Atualizar Assinatura",
                "body": {
                    "description": "Você tem certeza de que deseja atualizar seu plano de assinatura para <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Nota: O período de faturamento da assinatura permanecerá inalterado e você será cobrado apenas pelo valor excluindo o que já pagou pelo plano existente.</strong>"
                },
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        },
        "message": {
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "moduleNoAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        }
    },
    "confirmModal": {
        "header": "Confirme Suas Informações",
        "body": {
            "form": {
                "label": {
                    "firstName": "Nome",
                    "lastName": "Sobrenome",
                    "country": "País de Residência",
                    "refundPolicyAgreement": "Ao continuar, reconheço e aceito que este pagamento é final e não reembolsável. <1>Política de reembolso</1>",
                },
                "help_text": {
                    "firstName": "Por favor, confirme que este é seu Nome Legal.",
                    "lastName": "Por favor, confirme que este é seu Sobrenome Legal.",
                    "country": "Por favor, especifique seu país de residência atual."
                },
                "message": {
                    "error": "Ocorreu um erro ao criar a assinatura!",
                    "note": "Nota: A precisão das informações fornecidas aqui é essencial para os passos subsequentes. Certifique-se de que todas as informações sejam fornecidas de forma precisa e verdadeira."
                }
            }
        },
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Falha na Atualização da Assinatura :(",
            "description": "Houve um problema ao atualizar sua assinatura. Por favor, tente novamente mais tarde!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Assinatura Atualizada :)",
            "description": "Você atualizou sua assinatura com sucesso, sua conta será atualizada em breve!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transação Cancelada :(",
            "description": "A transação foi cancelada... Por favor, tente novamente mais tarde!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transação Bem-Sucedida :)",
            "description": "Você confirmou sua assinatura com sucesso, sua conta será atualizada em breve!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    }
};

export default subscriptionPT;